import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { param, trim } from 'jquery';
import { Subject } from 'rxjs';
import { QueryParams, rgxKanaFullW, rgxKanaHalfW } from 'src/app/shared/constant';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { ScrUserInfInpService } from 'src/app/modules/examinee/auth/scr-user-inf-inp/scr-user-inf-inp.service';
import { RegisUser } from 'src/app/models/regis-user.model';
@Component({
  selector: 'app-scr-user-inf-inp',
  templateUrl: './scr-user-inf-inp.component.html',
  styleUrls: ['./scr-user-inf-inp.component.scss']
})
export class ScrUserInfInpComponent implements OnInit {
  htOrgCode: string;
  consulId: string;
  dateOfBirth: string;
  consulDay: string;
  consulNum: string;
  userId: string;
  timeRegis: string;
  user: RegisUser;
  dob: string;
  isMale: boolean;
  isFeMale: boolean;
  agreePolicy = false;
  isPolicyErr = false;
  isPwdErr = false;
  strPostalCode = '';
  public lstPostal: any[];
  inpPostalClss = 'form-control w280';
  inpAddress = 'inpAddress1';
  maxLength = 255;
  passConfirm: string;
  private patern: RegExp;
  isRequireName = false;
  isRequireKana = false;
  isRequireDob = false;
  isRequireGender = false;
  isRequirePhoneNum = false;
  isRequirePostalCode = false;
  isRequirePassword = false;
  isRequirePasswordCf = false;
  isPasswordCfNotSame = false;
  isRequireAddress1 = false;
  pwdErrMsg = '';
  pwdCfErrMsg = '';
  kanaErrMsg = '';
  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: ScrUserInfInpService,
    private loading: LoadingService,
    public util: Utility,
    private dialogModalService: DialogModalService,
  ) {
    this.user = new RegisUser();
    this.isMale = false;
    this.isFeMale = false;
    this.patern = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.]{8,}$/);
  }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.htOrgCode = this.activatedRoute.snapshot.queryParams[QueryParams.HtOrgCode];
    this.consulId = this.activatedRoute.snapshot.queryParams[QueryParams.ConsulId];
    this.userId = this.activatedRoute.snapshot.queryParams[QueryParams.UserId];
    this.timeRegis = this.activatedRoute.snapshot.queryParams[QueryParams.Time];
    this.dateOfBirth = this.activatedRoute.snapshot.queryParams[QueryParams.DateOfBirth];
    this.consulDay = this.activatedRoute.snapshot.queryParams[QueryParams.ConsulDay];
    this.consulNum = this.activatedRoute.snapshot.queryParams[QueryParams.ConsulNum];
    
    if (this.htOrgCode === undefined) {
      this.htOrgCode = null;
    }
    if (this.consulId === undefined) {
      this.consulId = null;
    }
    if (this.userId === undefined) {
      this.userId = null;
    }
    if (this.timeRegis === undefined) {
      this.timeRegis = null;
    }
    // if (this.htOrgCode === undefined || this.htOrgCode == null || this.htOrgCode.trim() === ''){
    //   this.router.navigateByUrl('404');
    // }
    if (this.userId === undefined || this.userId == null || this.userId.trim() === '') {
      this.router.navigateByUrl('404');
    }
    if (this.timeRegis === undefined || this.timeRegis == null || this.timeRegis.trim() === '') {
      this.router.navigateByUrl('404');
    }
    this.getInfo();
  }
  trimObj() {
    if (this.user == null) {
      return;
    }
    if (this.user.Adress1 !== null) {
      this.user.Adress1 = this.user.Adress1.trim();
    }
    if (this.user.Adress2 !== null) {
      this.user.Adress2 = this.user.Adress2.trim();
    }
    if (this.user.KanaName !== null) {
      this.user.KanaName = this.user.KanaName.trim();
    }
    if (this.user.Name !== null) {
      this.user.Name = this.user.Name.trim();
    }
    if (this.user.Password !== null) {
      this.user.Password = this.user.Password.trim();
    }
    if (this.user.PostalCode !== null) {
      this.user.PostalCode = this.user.PostalCode.trim();
    }
    if (this.user.Gender !== null) {
      this.user.Gender = this.user.Gender.trim();
    }
    if (this.user.CountryCode !== null) {
      this.user.CountryCode = this.user.CountryCode.trim();
    }
    if (this.user.DateOfBirth !== null) {
      this.user.DateOfBirth = this.user.DateOfBirth.trim();
    }
    if (this.user.PhoneNum !== null) {
      this.user.PhoneNum = this.user.PhoneNum.trim();
    }
  }
  SetValue(pVal, pProp: string, pNextItem = '') {
    this.user[pProp] = pVal;
    if (!this.util.isNullOrEmpty(pNextItem) && !this.util.isNullOrEmpty(pVal)) {
      this.FocusItem(pNextItem);
    }
    this.removeBorderAdress();
  }
  setGender(idx) {
    this.user.Gender = idx.toString();
  }
  getInfo() {
    const obj = {
      UserId: this.userId,
      TimeRegis: this.timeRegis,
      HtOrgCode: this.htOrgCode
    };
    this.service.checkUserInfo(obj).subscribe(res => {
      this.loading.setDisplay(false);
      if (this.util.isNullOrEmpty(res)) {
        return;
      }
      if (res.Status === '0') {
        const mess = this.translate.instant('MESS_URL_CANNOT_ACCESS_PLS_REGIS');
        this.dialogModalService.openErrorModal(mess).subscribe(() => {
          this.go0104();
        });
        return;
      }
      if (res.Status === '1') {
        const mess = this.translate.instant('MESS_URL_CANNOT_ACCESS_PLS_RESTART');
        this.dialogModalService.openErrorModal(mess).subscribe(() => {
          this.go0104();
        });
        return;
      }
      this.user = res.User;
      this.trimObj();
      this.strPostalCode = this.user?.PostalCode;
    });
  }
  ChangeDOB(event) {
    this.user.DateOfBirth = event?.replace(/\-/g, '');
    this.removeErrBorder(3);
  }
  go0104() {
    this.router.navigate(['/sending-authen-mail'], { queryParams: { htorgcode: this.htOrgCode, consulid: this.consulId } });
  }
  FocusItem(pItem: string) {
    const el = document.getElementById('inp' + pItem);
    if (el) {
      setTimeout(() => {
        el.focus();
      }, 1);
    }
  }
  onKeyPressInput(event) {
    // const kanaText = event.key;
    // if (rgxKanaFullW.test(kanaText) === true ) {
    //   return true;
    // }
    // return false;
    return true;
  }
  checkPwd(e) {
    let nowVal = e.target.value;
    const kanaText = e.data;
    if (e.which === 32) {
      nowVal = nowVal?.replace(/\s/g, '');
    }
    if (this.check2ByteFunc(kanaText)) {
      nowVal = nowVal?.replace(kanaText, '');
    }
    e.target.value = nowVal;
  }
  countLength(str) {
    let r = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
      // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        r += 1;
      } else {
        r += 2;
      }
    }
    return r;
  }
  check2ByteFunc(val) {
    const actualLen = val.length;
    const strLen = this.countLength(val);
    // tslint:disable-next-line: radix
    if (parseInt(actualLen) * 2 === strLen) {
      return true;
    }
    return false;
  }
  onKeyTodo(event: any) {
    const keyValues = event.target.value;
    if (this.check2ByteFunc(keyValues)) {
      // tslint:disable-next-line: only-arrow-functions
      event.target.value = keyValues.replace(/[\uFF00-\uFFFE]/g, function (char) {
        if (char >= '\uFF00' && char <= '\uFF5E') {
          return String.fromCharCode(
            ' '.charCodeAt(0) +
            (char.charCodeAt(0) - '\uFF00'.charCodeAt(0)));
        }
        return '';
      });
    }
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
  }
  onClickSearchAddress() {
    const strPostCode = this.strPostalCode.replace(' ', '');
    this.loading.setDisplay(true);
    this.lstPostal = [];
    this.service.SearchAddress(strPostCode).subscribe(
      res => {
        if (res != null && res !== undefined) {
          this.lstPostal = res;
        }
        this.FocusItem('Address1');
        this.loading.setDisplay(false);
      },
      err => {
        this.loading.setDisplay(false);
      }
    );
  }
  focusPostNum(val: string) {
    if (!this.util.isNullOrBlank(val)) {
      this.strPostalCode = val.replace(/\s/g, '');
    }
  }
  outFocusPostNum(val: string) {
    if (!this.util.isNullOrBlank(val) && val.length >= 7) {
      val = val.replace(/\s/g, '');
      this.strPostalCode = val.substring(0, 3) + ' ' + val.substring(3);
    }
  }
  removeBorderAdress() {
    $('#inpAddress1').addClass('error-border');
  }
  removeErrBorder(idx) {
    switch (idx) {
      case 1:
        $('.ctrl1').removeClass('error-border');
        break;
      case 2:
        $('.ctrl2').removeClass('error-border');
        break;
      case 3:
        $('#inpDOD').removeClass('error-border');
        break;
      case 4:
        $('.ctrl4').removeClass('error-border');
        break;
      case 5:
        $('.ctrl5 input').removeClass('error-border');
        break;
      case 6:
        $('.ctrl6').removeClass('error-border');
        break;
      case 7:
        $('.ctrl7').removeClass('error-border');
        break;
      case 8:
        $('.ctrl8').removeClass('error-border');
        break;
    }
  }
  getRequireMsg(key) {
    const msgRequired = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED');
    return msgRequired.replace('{0}', this.translate.instant(key));
  }
  regis() {
    $('.error-border').removeClass('error-border');
    this.isPolicyErr = false;
    this.isPwdErr = false;
    this.isRequireName = false;
    this.isRequireKana = false;
    this.isRequireDob = false;
    this.isRequireGender = false;
    this.isRequirePhoneNum = false;
    this.isRequirePostalCode = false;
    this.isRequirePassword = false;
    this.isRequirePasswordCf = false;
    this.isPasswordCfNotSame = false;
    this.isRequireAddress1 = false;
    let isValid = true;
    let id = null ;
    if (this.util.isNullOrEmpty(this.user.Name)) {
      this.isRequireName = true;
      $('.ctrl1').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#Name"
      }
    }
    if (this.util.isNullOrEmpty(this.user.KanaName) && this.user.CountryCode === 'JP') {
      this.isRequireKana = true;
      this.kanaErrMsg = this.getRequireMsg('STR_KANA_NAME_PLACEHOLDER');
      $('.ctrl2').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#KanaName"
      }
    }
    else if (rgxKanaFullW.test(this.user.KanaName) === false) {
      this.kanaErrMsg = this.translate.instant('MESS_ERR_KANA_ONLY');
      $('.ctrl2').addClass('error-border');
      isValid = false;
      this.isRequireKana = true;
      if(this.util.isNullOrEmpty(id)) {
        id = "#KanaName"
      }
    }
    if (this.util.isNullOrEmpty(this.user.DateOfBirth)) {
      this.isRequireDob = true;
      $('#inpDOD').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#inpDOD"
      }
    }
    if (this.util.isNullOrEmpty(this.user.Gender)) {
      this.isRequireGender = true;
      $('.ctrl4').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#1"
      }
    }
    if (this.util.isNullOrEmpty(this.user.PhoneNum)) {
      this.isRequirePhoneNum = true;
      $('.ctrl5 input').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = '#PhoneNum'
      }
    }
    if (this.util.isNullOrEmpty(this.strPostalCode)) {
      this.isRequirePostalCode = true;
      $('.ctrl8').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = '#PostalCode'
      }
    }
    if (this.util.isNullOrEmpty(this.user.Adress1)) {
      this.isRequireAddress1 = true;
      $('#inpAddress1').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#inpAddress"
      }
    }
    if (this.util.isNullOrEmpty(this.user.Password)) {
      this.isRequirePassword = true;
      this.pwdErrMsg = this.getRequireMsg('STR_NEW_PASSWORD');
      $('.ctrl6').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#Password"
      }
    }
    else if (this.user.Password.length > 16 || this.user.Password.length < 8) {
      const message = this.translate.instant('MESS_CMN_ERR_OVER_MIN_LENGTH').replace('{0}', this.translate.instant('STR_NEW_PASSWORD'))
        .replace('{1}', this.translate.instant('8'));
      this.pwdCfErrMsg = message;
      this.isRequirePassword = true;
      $('.ctrl6').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#Password"
      }
    }
    else if (!this.patern.test(this.user.Password)) {
      this.pwdErrMsg = this.translate.instant('MESS_ERR_WRONG_PW_FORMAT');
      this.isRequirePassword = true;
      $('.ctrl6').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#Password"
      }
    }
    if (this.util.isNullOrEmpty(this.passConfirm)) {
      this.isRequirePasswordCf = true;
      this.pwdCfErrMsg = this.getRequireMsg('STR_CONFIRM_PASSWORD');
      $('.ctrl7').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#PasswordCheck"
      }
    }
    else if (this.passConfirm.length > 16 || this.passConfirm.length < 8) {
      const message = this.translate.instant('MESS_CMN_ERR_OVER_MIN_LENGTH').replace('{0}', this.translate.instant('STR_CONFIRM_PASSWORD'))
        .replace('{1}', this.translate.instant('8'));
      this.pwdCfErrMsg = message;
      this.isRequirePasswordCf = true;
      $('.ctrl7').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#PasswordCheck"
      }
    }
    else if (!this.patern.test(this.passConfirm)) {
      this.pwdCfErrMsg = this.translate.instant('MESS_ERR_WRONG_PW_FORMAT');
      this.isRequirePasswordCf = true;
      $('.ctrl7').addClass('error-border');
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#PasswordCheck"
      }
    } else if (this.user.Password !== this.passConfirm) {
      $('.ctrl7').addClass('error-border');
      this.isPasswordCfNotSame = true;
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#PasswordCheck"
      }
    }
    if (!this.agreePolicy) {
      this.isPolicyErr = true;
      isValid = false;
      if(this.util.isNullOrEmpty(id)) {
        id = "#Policy"
      }
    }
    if (!this.util.isNullOrBlank(id)) {
      const a =  $(id).focus();
    }
    if (!isValid) {
      return;
    }
    this.user.PostalCode = this.strPostalCode.replace(/\s/g, '');
    const obj =
    {
      UserID: this.userId,
      MailAdress: this.user.MailAdress,
      Password: this.user.Password,
      Name: this.user.Name,
      KanaName: this.user.KanaName,
      DateOfBirth: this.user.DateOfBirth,
      Gender: this.user.Gender,
      PhoneNum: this.user.PhoneNum,
      PostalCode: this.user.PostalCode,
      Adress1: this.user.Adress1,
      Adress2: this.user.Adress2,
      HTOrgCode: this.htOrgCode,
      ConsulID: this.consulId,
      DateOfBirthIR: this.dateOfBirth,
      ConsulDay: this.consulDay,
      ConsulNum: this.consulNum,
      CountryCode: this.user.CountryCode,
      RegistrationDiv: this.user.RegistrationDiv
    };

    this.service.regisUser(obj).subscribe(res => {
      this.loading.setDisplay(false);
      if (this.util.isNullOrEmpty(res)) {
        return;
      }
      if (!res.Success) {
        this.dialogModalService.openErrorModal(this.translate.instant('MESS_ERR_REGIS_FAILED'));
        return;
      }
      const isQR = this.activatedRoute.snapshot.queryParams[QueryParams.IsQR];
      if ((isQR === 'False' || isQR === false) && !this.util.isNullOrEmpty(this.htOrgCode)) {
        // tslint:disable-next-line: max-line-length
        this.dialogModalService.openInfoModal(this.translate.instant('MESS_USING_ACCOUNT_REGISTERED_PLS_RESV').replace('{0}', this.user.HTOrgName)).subscribe(() => {
          this.go0301();
        });
      } else {
        this.dialogModalService.openInfoModal(this.translate.instant('MESS_USING_ACCOUNT_REGISTERED')).subscribe(() => {
          this.go0201();
        });
      }
    });
  }
  go0301() {
    this.autoLogin();
    this.router.navigate(['/insurance-sel'], { queryParams: { htorgcode: this.htOrgCode } });
  }
  autoLogin() {
    const saveInfo: any = {};
    const loginData = this.user;
    saveInfo.UserID = this.userId?.trim();
    saveInfo.MailAdress = loginData.MailAdress?.trim();
    saveInfo.Name = loginData.Name?.trim();
    saveInfo.KanaName = loginData.KanaName?.trim();
    saveInfo.DateOfBirth = loginData.DateOfBirth?.trim();
    saveInfo.Gender = loginData.Gender.trim();
    saveInfo.PhoneNum = loginData.PhoneNum?.trim();
    saveInfo.PostalCode = loginData.PostalCode?.trim();
    saveInfo.Adress1 = loginData.Adress1?.trim();
    saveInfo.Adress2 = loginData.Adress2?.trim();
    saveInfo.RegistrationDiv = loginData.RegistrationDiv?.trim();
    saveInfo.CountryCode = loginData.CountryCode?.trim();
    localStorage.removeItem('ExamineauthorizationData');
    localStorage.ExamineauthorizationData = JSON.stringify(saveInfo);
    localStorage.fLogin = 'true';
  }
  go0201() {
    this.autoLogin();
    this.router.navigateByUrl('toppage');
  }
  setValuePhoneNum(value) {
    this.user.PhoneNum = value;
  }
}
